import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const PremiereCountdown = ({ date, label = "Full episode premieres in", className = "" }) => {
  const target = new Date(date).getTime();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = target - now;
  if (diff <= 0) {
    return (
      <p className="text-[11px] tracking-[0.3em] uppercase text-gold-light" data-testid="premiere-countdown">
        Now streaming
      </p>
    );
  }

  const units = [
    [Math.floor(diff / 86400000), "Days"],
    [Math.floor((diff % 86400000) / 3600000), "Hours"],
    [Math.floor((diff % 3600000) / 60000), "Min"],
    [Math.floor((diff % 60000) / 1000), "Sec"],
  ];

  return (
    <div className={className} data-testid="premiere-countdown">
      <p className="text-[10px] tracking-[0.3em] uppercase text-smoke mb-3">{label}</p>
      <div className="flex items-center gap-5">
        {units.map(([v, l]) => (
          <div key={l} className="text-center">
            <p className="font-display text-2xl md:text-3xl text-gold-light leading-none" data-testid={`countdown-${l.toLowerCase()}`}>
              {pad(v)}
            </p>
            <p className="text-[9px] tracking-[0.24em] uppercase text-smoke mt-1.5">{l}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
